import { render, staticRenderFns } from "./getReturnData.vue?vue&type=template&id=081d2da4&"
import script from "./getReturnData.vue?vue&type=script&lang=js&"
export * from "./getReturnData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports